module.exports = __webpack_public_path__ + "static/media/problem-definition@3x.a7ef98a3.png";